import loadable from '@loadable/component';

export const OrgDashboardEditEventPageContainerLoadable = loadable(
  () => import('./OrgDashboardEditEventPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardEditEventPageContainer,
    ssr: false,
  },
);
